import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
import survey from './survey-module'
import respondent from './respondent-module'
import user from './user-module'
import surveyStore from './survey-store-module'
import {SessionService} from '@parantion/components'
import packageJson from '../../package.json'
import * as Comlink from 'comlink'
import PersistenStoreWorker from "worker-loader!./PersistenStoreWorker.ts";
import {debounce} from 'lodash-es'

const worker = new PersistenStoreWorker()
const persistentStoreWorker = Comlink.wrap(worker)

Vue.use(Vuex)

const service = SessionService.getInstance(packageJson.name)
service.setSession()
const sessionKey = service.sessionKey

function setStorage (key, state) {
  persistentStoreWorker.store(key, state)
}

const debouncedSetStorage = debounce(setStorage, 500)

const vuexAsync = new VuexPersistence({
  key: sessionKey,
  saveState: (key, state) => {
    return debouncedSetStorage(key, state)
  },
  restoreState: async (key) => {
    return await persistentStoreWorker.retrieve(key)
  },
  asyncStorage: true
})

const vuexLocal = new VuexPersistence({
  key: sessionKey,
  storage: window.sessionStorage,
  reducer: (state) => ({
    parantion: {
      baseUrl: state.parantion.baseUrl,
      database: state.parantion.database,
      domain: state.parantion.domain,
      environment: state.parantion.environment,
      subdomains: state.parantion.subdomains,
      useLockScreen: state.parantion.useLockScreen,
      autoLockscreen: state.parantion.autoLockscreen,
      lockoutTime: state.parantion.lockoutTime,
      warningTime: state.parantion.warningTime,
      user: state.parantion.user,
      rights: {
        access_link_available: '0'
      }
    }
  })
})

const store = new Vuex.Store({
  plugins: [vuexAsync.plugin, vuexLocal.plugin],
  modules: {survey, respondent, user, surveyStore}
})

export default store
